"use client";
// eslint-disable-next-line @typescript-eslint/no-unused-expressions
import { UserWithCompanies } from "@/components/auth";
import { AppStoreState } from "@/store/appStore";

import {
  useAppStore,
  selectUser,
  selectSelectedCompany,
  selectBankAccounts,
} from "@/store/appStore";
import { FC, useState, useEffect } from "react";
import { Wallet } from "lucide-react";
import { Plus } from "lucide-react";
import { StatementsProps } from "./accounts.types";
import { Content } from "../components/page/components";
import { ContentHeader } from "../components";
import { List } from "../components/list";
import { CurrencyCode, MenuItem } from "@/components/ui";
import IBAN from "iban";
import { BankSelector } from "@/components/bank-selector";
import { UserExtended, AccountExtended } from "@/types";
import dayjs from "dayjs";

const Accounts: FC<StatementsProps> = () => {
  // Get selectedCompany directly from Zustand store, matching Space Selector
  const selectedCompany = useAppStore((s: AppStoreState) => s.selectedCompany);
  const accounts =
    useAppStore(selectBankAccounts)
      ?.filter((a: AccountExtended) => a.companyId === selectedCompany?.id)
      .sort((a: AccountExtended, b: AccountExtended) => {
        return (
          new Date(b.createdAt).getTime() - new Date(a.createdAt).getTime()
        );
      }) || [];

  console.log("AccountsPage: accounts", accounts);

  // Data loading is now handled by setSelectedCompany in the store

  const [selected, setSelected] = useState(accounts[0] ?? null);

  // Data loading is now handled by setSelectedCompany in the store

  // Guard: don't render until user and selectedCompany are loaded
  console.log("selectedCompany", selectedCompany);

  return (
    <>
      <Content>
        <ContentHeader
          datePicker={false}
          title={{
            value: "Accounts",
            icon: Wallet,
            align: "left",
          }}
          actions={[
            {
              icon: Plus,
              text: "Connect Bank",
              dialog: BankSelector,
            },
          ]}
        />
        <List
          groupBy={(account) =>
            account.institution && account.institution.name
              ? account.institution.name
              : "N/A"
          }
          sortGroupBy={(a, b) => (a && b ? a.localeCompare(b) : 0)}
          title={(account) => {
            return (
              <MenuItem
                label={
                  account.institution && account.institution.name
                    ? account.institution.name
                    : "N/A"
                }
                image={{
                  type: "avatar",
                  source:
                    account.institution && account.institution.logo
                      ? account.institution.logo
                      : undefined,
                  fallback:
                    account.institution && account.institution.name
                      ? account.institution.name.charAt(0)
                      : "",
                }}
                className="flex flex-row items-center"
              />
            );
          }}
          items={accounts.map((account: AccountExtended) => ({
            label: account.iban
              ? IBAN.printFormat(account.iban)
              : account.bban
              ? IBAN.printFormat(account.bban)
              : undefined,
            description: account.currency || undefined,
            amount: account.balance ?? undefined,
            currency: account.currency as CurrencyCode,
            isSelected: selected?.id === account.id,
            //status: 'COMPLETED', //TODO: Dynamic Workflow Status
            onClick: () => {
              setSelected(account);
            },
            onUpdate: () => {},
            onRemove: () => {},
            image: {
              type: "currency",
              source: account.currency || undefined,
              size: "L",
              fallback:
                account.institution && account.institution.name
                  ? account.institution.name.slice(0, 2).toUpperCase()
                  : "N/A",
            },
            institution: account.institution,
          }))}
        />
      </Content>

      {/*selected && (
      <StatementContextPanel statement={selected} />
      )*/}
    </>
  );
};

export { Accounts };
